import src from "IMAGE";
export default { src, width: 432, height: 200, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAASklEQVR42k3NOwqAMBRE0WnUFVjZKfjBQsRlCCGEkP0vJTcwRYrDFO/Ck6QfCQtGG7yTfCy48ODzvrhbEJGx4XB4emf5RcDqaO9VXTEFiP+eWh4AAAAASUVORK5CYII="};
